import { Add, Check } from '@mui/icons-material';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { FC, useEffect, useRef, useState } from 'react';
import { TPricingCardSmallProps } from './types';

const scrollbarWidth = () => {
	const documentWidth = document.documentElement.clientWidth;
	const windowsWidth = window.innerWidth;
	return +windowsWidth - +documentWidth;
};

export const PricingCardSmall: FC<TPricingCardSmallProps> = ({ data, text, text2 }) => {
	const refCurrentPlan = useRef<HTMLDivElement>(null);
	const value = (+(data?.monthly_fee_value ?? 0)).toFixed(2).split('.')[0];
	const coins = (+(data?.monthly_fee_value ?? 0)).toFixed(2).split('.')[1];

	const { body } = document;
	const [padding, setPadding] = useState(19);

	const [expanded, setExpanded] = useState(false);

	useEffect(() => {
		if (!expanded) {
			setPadding(scrollbarWidth());
		}
	}, [expanded]);

	const handleExpandClick = () => {
		setExpanded(!expanded);

		if (expanded) {
			body.style.overflow = 'auto';
			// body.style.paddingRight = `${padding}px`;
			body.style.paddingRight = `0px`;
		}
		if (!expanded) {
			body.style.overflow = 'hidden';
			body.style.paddingRight = `${padding}px`;
		}
	};

	const items = () => {
		const i = [];
		if (data.transaction_plan) {
			if (data.IOSS) i.push({ type: 'free', name: `${data.IOSS} per IOSS or UK import order` });
			if (data.OSS) i.push({ type: 'free', name: `${data.OSS} per OSS order` });
			if (data.NON_UNION) i.push({ type: 'free', name: `${data.NON_UNION}` });
			if (data.B2C) i.push({ type: 'free', name: `${data.B2C} per B2C domestic order` });
			if (data.FC) i.push({ type: 'free', name: `${data.FC} per DDP/DDU order` });

			if (data.invoicing_fee_value)
				i.push({
					type: 'add',
					name: `${data.invoicing_fee_value}€ Invoicing fee for invoices over ${data.invoice_threshold_eur} €`,
				});
		} else {
			if (data.ioss_uk_monthly_free) i.push({ type: 'free', name: data.ioss_uk_monthly_free });
			if (data.oss_monthly_free) i.push({ type: 'free', name: data.oss_monthly_free });
			if (data.ioss_uk_monthly_add)
				i.push({ type: 'add', name: data.ioss_uk_monthly_add, value: data.IOSS });
			if (data.oss_monthly_add)
				i.push({ type: 'add', name: data.oss_monthly_add, value: data.OSS });
			if (data.non_union_monthly_add)
				i.push({ type: 'add', name: data.non_union_monthly_add, value: data.NON_UNION });
		}
		return i;
	};

	return (
		<Box
			sx={{
				position: 'relative',
				width: data.transaction_plan ? '360px' : '460px',
				// zIndex: 1200,
				m: 0,
				p: 0,
			}}
			ref={refCurrentPlan}
		>
			<Box
				sx={{
					position: 'fixed',
					zIndex: 1500,
					right: 0,
					bottom: 0,
					top: 0,
					left: 0,
					// opacity: 1,
					// transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
					// backgroundColor: 'rgba(0, 0, 0, 0.5)',
					visibility: expanded ? 'visible' : 'hidden',
					pointerEvents: expanded ? 'auto' : 'none',
					height: '100vh',
					width: '100vw',
					overflow: 'hidden',
				}}
				onClick={handleExpandClick}
			/>
			<Card
				sx={{
					// minWidth: 430,
					// minHeight: 74,
					top: expanded ? refCurrentPlan.current?.getBoundingClientRect().top : 'auto',
					left: expanded ? refCurrentPlan.current?.getBoundingClientRect().left : 'auto',
					width: data.transaction_plan ? '360px' : '460px',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
					alignItems: 'center',
					m: 0,
					p: 0,
					position: expanded ? 'fixed' : 'relative',
					cursor: 'pointer',
					// transition: 'all 2s',
					zIndex: 1100,
				}}
				onClick={handleExpandClick}
			>
				<CardContent
					sx={{
						m: 0,
						p: '0!important',
						width: '100%',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'start',
							alignItems: 'space-between',
							gap: 0,
							// borderBottom: expanded ? '2px solid #016193' : 'none',
						}}
					>
						<Box
							color="primary"
							sx={{
								backgroundColor: 'primary.main',
								color: 'white',
								height: '80px',
								maxHeight: '80px',
								// width: data.transaction_plan ? '300px' : '240px',
								width: '360px',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'start',
								justifyContent: 'space-between',
								p: '4px 8px',
							}}
						>
							<Typography
								sx={{
									fontSize: '0.75rem',
									m: 0,
									p: 0,
								}}
							>
								{text} {text2}
							</Typography>

							<Typography
								component="div"
								sx={{
									fontSize: '1rem',
									fontWeight: 'bold',
									m: 0,
									p: 0,
								}}
							>
								{data.transaction_plan ? 'Transaction based pricing' : data.name_for_invoice}
							</Typography>
							<Typography
								sx={{
									fontSize: '0.7rem',
									lineHeight: '1.1',
									maxWidth: '350px',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}
							>
								{!expanded && data.transaction_plan && (data.IOSS || data.OSS || data.NON_UNION)
									? `${data.IOSS && `IOSS: ${data.IOSS}, `}${data.OSS && `OSS: ${data.OSS}, `}${data.NON_UNION && `NON UNION: ${data.NON_UNION}`}`
									: (data.dashboard_description ?? <span>&nbsp;</span>)}
							</Typography>
							<Typography
								sx={{
									fontSize: '0.75rem',
									fontWeight: 'bold',
								}}
							>
								{expanded ? 'Press to hide details' : 'Press for more details'}
							</Typography>
						</Box>
						{!data.transaction_plan && (
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'top',
									alignItems: 'center',
									backgroundColor: '#01619336',
									p: '5px',
								}}
							>
								<Box
									sx={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'center',
										alignItems: 'top',
										mt: '-5px',
										p: '0 4px 0 0',
									}}
								>
									<Typography
										component="span"
										color="primary"
										sx={{
											fontSize: '0.9rem',
											fontWeight: 'bold',
											mt: '9px',
											mr: '2px',
											p: 0,
											color: 'primary.main',
										}}
									>
										€
									</Typography>
									<Typography
										component="div"
										color="primary"
										sx={{
											fontSize: '2.2rem',
											fontWeight: 'bold',
											m: 0,
											p: 0,
											color: 'primary.main',
										}}
									>
										{value}
									</Typography>
									{
										// !!+coins &&
										<Typography
											component="span"
											color="primary"
											sx={{
												fontSize: '0.9rem',
												fontWeight: 'bold',
												mt: '9px',
												mr: '2px',
												p: 0,
												color: 'primary.main',
											}}
										>
											{coins}
										</Typography>
									}
								</Box>
								<Typography
									sx={{
										fontSize: '0.7rem',
										mt: '-15px',
										p: 0,
										color: 'primary.main',
									}}
									color="primary"
								>
									month
								</Typography>
							</Box>
						)}
					</Box>
					{expanded && (
						<Box>
							{items().map((i) => (
								<Box
									key={i.name}
									sx={{
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'start',
										p: '4px',
									}}
								>
									{i.type === 'free' ? (
										<Check color="success" fontSize="small" />
									) : (
										<Add color="primary" fontSize="small" />
									)}
									<Typography
										color={i.type === 'free' ? 'success.main' : 'primary'}
										sx={{
											ml: '5px',
											color: i.type === 'free' ? 'success.main' : 'primary.main',
											fontSize: '0.9rem',
										}}
									>
										{i?.value ? `${i?.value} ` : ''}
										{i.name}
									</Typography>
								</Box>
							))}
						</Box>
					)}
				</CardContent>
			</Card>
		</Box>
	);
};
